import React from "react";
import { FEASIBILITY_META } from "../../lib/constants";
import { cn } from "../../lib/utils";

export function FeasibilityBadge({ status, size = "md", className, "data-testid": testId }) {
  const meta = FEASIBILITY_META[status];
  if (!meta) {
    return (
      <span
        data-testid={testId || "feasibility-badge-unknown"}
        className={cn("inline-flex items-center gap-2 rounded px-2 py-1 text-xs bg-slate-100 text-slate-700", className)}
      >
        {status || "Unknown"}
      </span>
    );
  }
  const isLarge = size === "lg";
  return (
    <span
      role="status"
      aria-label={meta.aria}
      data-testid={testId || `feasibility-badge-${status.toLowerCase()}`}
      className={cn(
        "inline-flex items-center gap-2 rounded font-medium border",
        isLarge ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-xs",
        meta.bg, meta.text, meta.border,
        meta.pattern ? "border-dashed" : "border-solid",
        className,
      )}
    >
      <span aria-hidden="true" className={cn("h-2 w-2 rounded-full", meta.dot)} />
      {meta.label}
    </span>
  );
}
